var archivePage = {
	current: 1,
	max: 0
}
var loadPage = {
	isLoadMore: false,
	load: function(){
		let $load, $loadBlock;
		if(page.type === "spot"){
			console.log("%cLOAD spot search result", 'color: green');
			$load 		= "#search_layer_spot .load_inner";
			$loadBlock 	= "#load_spot_layer .layer_content";
		}else if(page.type === "deck"){
			console.log("%cLOAD deck search result", 'color: green');
			$load 		= "#search_layer_deck .load_inner";
			$loadBlock 	= "#load_deck_layer .layer_content";
			$("#search_layer_deck").addClass("disable");
		}
		if(fw.isFirst){
			fw.afterChangePage();
		}else{
			let searchResultURL = location.pathname + "?type=" + page.type;
			//console.log(searchResultURL);
			$.get(searchResultURL, {},function(data){
				var out_html 	= $(data);
				setTimeout(function(){
					loadPage.changeContent(out_html, $load, $loadBlock).done(function(){
						if( $("body").hasClass("is_spot_detail") ){
							spot.hideSpotDetail();
						}
						archivePage.current = 1;
						archivePage.max = $(".wrap_more", $load).attr("data-max");
						fw.afterChangePage();
					});
				}, 600);
			});
		}
	},
	loadSpot: function(){
		var defer = $.Deferred();
		//console.log("%cLOAD SPOT", 'color: green');
		let $load 		= "#spot .load_inner";
		let $loadBlock 	= "#load_spot .spot_content";

		let spotDetailURL = location.pathname;
		$.get(spotDetailURL, {},function(data){
			var out_html 	= $(data);
			loadPage.changeContent(out_html, $load, $loadBlock).done(function(){
				//console.log("spot loaded")
				setTimeout(function(){
					defer.resolve();
				}, 100);
			});
		});
		return defer.promise();
	},
	loadCardView: function(){
		var defer = $.Deferred();
		let $load 		= "#deck_cardview .load_inner";
		let $loadBlock 	= "#load_cardview .cardview_content";

		let cardViewURL = location.pathname;
		$.get(cardViewURL, {},function(data){
			var out_html 	= $(data);
			let $mapContent = $( "#load_map .map_load_inner", out_html )[0];
			$("#map_view .map_load").html($mapContent);
			//common.scrollToPosition(0, 200);
			loadPage.changeContent(out_html, $load, $loadBlock).done(function(){
				cardview.resize();
				cardview.show();
				common.closeLoading().done(function(){
					defer.resolve();
				});
			});
		});
		return defer.promise();
	},
	changeContent: function(data, $load, $loadBlock){
		var defer = $.Deferred();
		//observer.disconnect();
		var out_html 	= $(data),
			ttl 		= out_html.filter("title")[0].innerHTML,
			$content 	= $( $load ),
			content 	= $( $loadBlock, out_html )[0],
			postTitle 	= $("header", out_html)[0];
		$content.html(content);
		document.title = ttl;
		setTimeout(function(){
			let imgArry = [];
			//スポットの時はローディングを走らせる
			if(page.folder === "spot" && page.currentURL.length === folderNum && page.param === ""){
				$content.find("img").each(function(){
					let imgsrc = $(this).attr("src");
					let type = getExt(imgsrc);
					//console.log(type)
					if(type === "jpg" || type === "png"){
						imgArry.push($(this).attr("src"));
					}
				});
				if(imgArry.length > 0){
					preload.startLoad(imgArry.length,imgArry).done(function(){
						defer.resolve();
					});
				}else{
					setTimeout(function(){
						defer.resolve();
					}, 50);
				}
			}else{
				setTimeout(function(){
					defer.resolve();
				}, 50);
			}
		},50);
		
		return defer.promise();
	},
	overrideTitle: function(){
		//console.trace("%cOverrideTitle", 'color: silver');
		$(".header_decks h3 span").html("");
		$(".header_spot_detail h3").html("");
		//console.log(page.currentURL.length, folderNum)
		if(page.currentURL.length === folderNum){
			if(page.folder === "spot"){
				if(page.type === "spot"){
					let ttl = $("#search_layer_spot .search_detail_list").attr("data-name");
					$("header#glb_header .header_spot h3 span").html(":" + ttl);
					//console.log("%cspot search result", 'color: red')
				}else{
					let ttl = $("#spot .ttl_main_spot h3").text();
					$("header#glb_header .header_spot_detail h3.ttl_spot").html(ttl);
					//console.log("%cspot detail", 'color: red')
				}
			}else if(page.folder === "deck"){
				if(page.type === "deck"){
					//console.log("%cdeck search result", 'color: red')
					let ttl = $("#search_layer_deck .search_detail_list").attr("data-name");
					$("header#glb_header .header_decks h3.ttl_deck span").html(":" + ttl);
				}else{
					if(page.param === "map"){
						let ttl = $("#load_cardview .cardview_content").attr("data-name");
						$("header#glb_header .header_decks_detail h3.ttl_deck").html(ttl);
					}else{
						let ttl = $("#load_cardview .cardview_content").attr("data-name");
						$("header#glb_header .header_decks_detail h3.ttl_deck").html(ttl);
					}
					//console.log("%cdeck detail", 'color: red')
				}
			}
		}else if(page.currentURL.length === homeNum){
			$("header#glb_header .header_decks h3.ttl_deck span").html("");
			$("header#glb_header .header_spot h3 span").html("");
			if(page.folder === "spot"){
				let activeCat = $("#nav_search li a.active span").text();
				document.title = activeCat + " | SPOT | " + $("body").attr("data-title");
			}else if(page.folder === "deck"){
				let activeCat = $("#nav_search li a.active span").text();
				document.title = activeCat + " | DECKS | " + $("body").attr("data-title");
			}else{
				document.title = $("body").attr("data-title");
			}
		}
		fw.checkHeader();
	},
	loadMoreArchive: function(url){
		let $load, $loadBlock;
		if(page.type === "spot"){
			console.log("%cLOAD more archive spot", 'color: green');
			$load 		= "#search_layer_spot .load_inner";
			$loadBlock 	= "#load_spot_layer .layer_content";
		}else if(page.type === "deck"){
			console.log("%cLOAD more archive deck", 'color: green');
			$load 		= "#search_layer_deck .load_inner";
			$loadBlock 	= "#load_deck_layer .layer_content";
		}
		//console.log(searchResultURL);
		//console.log(url, archivePage);
		$.get(url, {},function(data){
			var out_html 	= $(data);
			if(page.type === "deck"){
				let listHTML = "";
				let content = $("#load_deck_layer .list_col3_deck", out_html)[0];
				listHTML = $(content).html();
				//console.log(listHTML);
				$("#load_deck_layer ul.list_col3_deck").append(listHTML);
			}
			if(archivePage > 1){

			}else{
				fw.afterChangePage();
				setTimeout(function(){
					loadPage.isLoadMore = false;
				}, 300)
			}
			
			/*
			loadPage.addContent(out_html, $load, $loadBlock).done(function(){
				if( $("body").hasClass("is_spot_detail") ){
					spot.hideSpotDetail();
				}
				archivePage.current = 1;
				archivePage.max = $(".wrap_more", $load).attr("data-max");
				fw.afterChangePage();
			});
			*/
		});
	}
}
function getExt(filename){
	var pos = filename.lastIndexOf('.');
	if (pos === -1) return '';
	return filename.slice(pos + 1);
}